import { useAuthStore } from '@ipsoftsrl/frontend-auth';

/**
 * Dashboard — shows available portals for the authenticated user.
 */
export function DashboardPage() {
  const user = useAuthStore((s) => s.user);

  return (
    <div className="dashboard-page">
      <h2>Benvenuto, {user?.givenName}!</h2>
      <p>Seleziona un portale per accedere ai servizi.</p>

      <div className="portal-grid" role="list" aria-label="Portali disponibili">
        {/* Portals will be loaded dynamically based on user permissions */}
        <PortalCard
          code="documentale"
          name="Documentale Dipendenti"
          description="Gestione documenti personali e aziendali"
          icon="📄"
        />
      </div>
    </div>
  );
}

function PortalCard(props: { code: string; name: string; description: string; icon: string }) {
  return (
    <a
      href={`/portals/${props.code}`}
      className="portal-card"
      role="listitem"
      aria-label={`Accedi a ${props.name}`}
    >
      <span className="portal-card-icon" aria-hidden="true">{props.icon}</span>
      <h3>{props.name}</h3>
      <p>{props.description}</p>
    </a>
  );
}
